import { connect } from 'react-redux';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getBookedEntertainments, setSelectedNumOfGuests } from '../redux/actions/bookedEntertainments';
import { saveEntertainment, deleteEntertainment } from '../redux/actions/changeAddon';
import { getBackstopDateFromApi } from '../redux/actions/backstopDate';
import EntertainmentDetail from '../components/entertainmentDetail/EntertainmentDetail';
import {
  shouldFetch,
  filterBookedEntertainments,
  getShouldSkipSwimmingOrEntertainment,
  shouldFetchAvailableItems,
  getIsPerPersonActivity,
  getSelectedActivityByCode,
  getQuantity,
  getBackstopDate,
  shouldFetchBackstopDate,
} from '../utils';

const mapStateToProps = ({ availableEntertainments, bookingSearch, bookedEntertainments, bookedEvents, config, backstopDate }, { entertainmentId }) => {
  const { entertainments } = availableEntertainments;
  const { selectedNumOfGuests } = bookedEntertainments;
  const {
    arrivalDate,
    numOfUnits,
    numOfGuests,
    resId,
    siteCode,
    maxAllowedShowBookingSlots,
    departureDate,
    seasonSuffix,
    isEarlyAccess,
  } = bookingSearch;
  const selectedActivity = getSelectedActivityByCode(entertainments, entertainmentId);
  const isPerPersonActivity = selectedActivity && getIsPerPersonActivity(config, selectedActivity.activityId);
  const maxQuantity = getQuantity(selectedActivity.name, numOfUnits, numOfGuests, isPerPersonActivity);
  const quantityToBook = !isPerPersonActivity ? numOfUnits : selectedNumOfGuests;

  return {
    entertainments,
    title: 'Setup your experience',
    subTitle: 'Entertainment',
    optionTitle: 'Select performance time...',
    separatorLabel: 'Venue closed for deep clean',
    resId,
    siteCode,
    entertainmentId,
    shouldFetchAvailableEntertainments: shouldFetchAvailableItems(availableEntertainments, bookingSearch, config, bookedEntertainments),
    shouldSkip: getShouldSkipSwimmingOrEntertainment(availableEntertainments.wasCalled, availableEntertainments.entertainments),
    bookedEntertainmentsWithoutPastEvents: filterBookedEntertainments(entertainments, bookedEntertainments.entertainments),
    allBookedEntertainments: bookedEntertainments.entertainments,
    shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
    maxAllowedShowBookingSlots,
    bookedEvents: bookedEvents.events,
    lateBookingWindowMinutes: parseInt(config.REACT_APP_LATE_BOOKING_WINDOW_MINUTES, 10) || 0,
    overlapAllowedMinutes: parseInt(config.REACT_APP_OVERLAP_ALLOWED_MINUTES, 10) || 0,
    overlapCheckPoolItems: config.REACT_APP_OVERLAP_CHECK_POOL === 'true',
    allowLateBooking: config.REACT_APP_ALLOW_LATE_BOOKING === 'true',
    preventOverlapMandatory: config.REACT_APP_PREVENT_OVERLAP_MANDATORY === 'true',
    xmasCollectionActId: parseInt(config.REACT_APP_CHRISTMAS_COLLECTION, 10) || 0,
    xmasExperienceActId: parseInt(config.REACT_APP_CHRISTMAS_EXPERIENCE, 10) || 0,
    eveningShowRestrictionStartDate: config.REACT_APP_EVENING_SHOW_RESTRICTION_START_DATE,
    eveningShowRestrictionEndDate: config.REACT_APP_EVENING_SHOW_RESTRICTION_END_DATE,
    eveningShowRestrictionStartTime: config.REACT_APP_EVENING_SHOW_RESTRICTION_START_TIME,
    eveningShowRestrictionEndTime: config.REACT_APP_EVENING_SHOW_RESTRICTION_END_TIME,
    additionalEveningShowTime: config.REACT_APP_ADDITIONAL_EVENING_SHOW_TIME,
    refreshTimeInterval: parseInt(config.REACT_APP_REFRESH_TIME_INTERVAL, 10) || 15,
    lastConfigCheckDateTime: config.lastConfigCheckDateTime,
    specialBreaks: config.specialBreaks,
    isPerPersonActivity,
    quantityToBook,
    maxQuantity,
    backstopDate: getBackstopDate({ config, departureDate, arrivalDate, backstopDateFromApi: backstopDate.backstopDate, seasonSuffix, isEarlyAccess }),
    shouldFetchBackstopDate: shouldFetchBackstopDate(config, backstopDate, bookingSearch),
    xmasActivityMessage: config.REACT_APP_CHRISTMAS_ACTIVITY_MESSAGE,
    showRestrictId1: parseInt(config.REACT_APP_SHOWRESTRICTID1, 10) || 0,
    showRestrictId2: parseInt(config.REACT_APP_SHOWRESTRICTID2, 10) || 0,
    showRestrictionMessage: config.REACT_APP_RESTRICTED_ACTIVITY_MESSAGE,
  };
};

const mapDispatchToProps = dispatch => ({
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
  saveEntertainment: (entertainmentsToSave, type) => dispatch(saveEntertainment(entertainmentsToSave, type)),
  deleteEntertainment: (resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, needToReportToGTM) => dispatch(
    deleteEntertainment(resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, needToReportToGTM),
  ),
  setSelectedNumOfGuests: numOfGuests => dispatch(setSelectedNumOfGuests(numOfGuests)),
  getBackstopDateFromApi: () => dispatch(getBackstopDateFromApi()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EntertainmentDetail);
